const theme = {
  colors: {
    light: '#fff',
    dark: '#343a40',

    primary: '#000',
    secondary: '#6c757d',
    success: '#28a745',
    danger: '#dc3545',
    warning: '#ffc107',
    info: '#17a2b8',
    muted: '#6c757d',
    divider: '#e5e5e5',

    blue: '#0d6efd',
    indigo: '#6610f2',
    purple: '#6f42c1',
    pink: '#d63384',
    red: '#ff0a00',
    orange: '#fd7e14',
    yellow: '#ffc107',
    green: '#198754',
    teal: '#20c997',
    cyan: '#0dcaf0',

    white: '#fff',
    black: '#000',
    gray100: '#f8f9fa',
    gray200: '#e9ecef',
    gray300: '#dee2e6',
    gray400: '#ced4da',
    gray500: '#adb5bd',
    gray600: '#6c757d',
    gray700: '#495057',
    gray800: '#343a40',
    gray900: '#212529',

    pageBackground: '#edecec',
  },
  breakpoint: {
    xs: '576px',
    sm: '768px',
    md: '992px',
    lg: '1200px',

    monitorSmall: '1366px',
  },
};

export default theme;
